import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "shorteval" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  id: "shorteval-form-service-not-running"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 4,
  id: "shorteval-form-intensive-use"
}
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_form_component = _resolveComponent("form-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.settings.title && !_ctx.showResultPage)
          ? (_openBlock(), _createElementBlock("h1", {
              key: 0,
              class: "shorteval-title",
              innerHTML: _ctx.settings.title
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.settings.intro && !_ctx.showResultPage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          innerHTML: _ctx.settings.intro
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.settings.moreDetailsTitle  && !_ctx.showResultPage)
      ? (_openBlock(), _createBlock(_component_modal_component, {
          key: 1,
          "btn-title": 'Weitere Informationen',
          title: _ctx.settings.moreDetailsTitle,
          body: _ctx.settings.moreDetailsBody,
          closeButtonText: _ctx.labels.close,
          "cancel-button-text": 'Schließen',
          "cancel-button-class": 'btn btn-outline-secondary',
          "show-cancel-button": true,
          "show-confirm-button": false,
          link: 'link',
          "btn-class": 'shorteval-btn',
          "icon-path-before": _ctx.icons.info
        }, null, 8, ["title", "body", "closeButtonText", "icon-path-before"]))
      : _createCommentVNode("", true),
    (_ctx.isVisibleForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.showResultPage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["progress-bar-custom sticky-progress", { 'is-sticky': _ctx.isStickyProgressBar, 'hidden': !_ctx.isStickyProgressBar }])
              }, [
                _createVNode(_component_el_progress, {
                  percentage: _ctx.progressBarData,
                  color: '#183462',
                  "stroke-width": 10,
                  class: _normalizeClass('mb-4'),
                  "show-text": false
                }, null, 8, ["percentage"])
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_form_component)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isVisibleForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", { innerHTML: _ctx.serviceNotRunningMessage }, null, 8, _hoisted_8),
          _createVNode(_component_modal_component, {
            title: _ctx.serviceNotRunningTitle,
            body: _ctx.serviceNotRunningMessage,
            "cancel-button-text": 'Schließen',
            "cancel-button-class": 'btn btn-outline-secondary',
            "show-cancel-button": true,
            "show-confirm-button": false,
            link: 'link',
            "btn-class": 'text-decoration-underline',
            "open-modal-without-button": true,
            "custom-class": 'show-warning-triangle'
          }, null, 8, ["title", "body"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isIntensiveUsedApi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", { innerHTML: _ctx.isIntensiveUsedApiMessage }, null, 8, _hoisted_10),
          _createVNode(_component_modal_component, {
            title: _ctx.isIntensiveUsedApiTitle,
            body: _ctx.isIntensiveUsedApiMessage,
            "cancel-button-text": 'Schließen',
            "cancel-button-class": 'btn btn-outline-secondary',
            "show-cancel-button": true,
            "show-confirm-button": false,
            link: 'link',
            "btn-class": 'text-decoration-underline',
            "open-modal-without-button": true,
            "custom-class": 'show-warning-triangle'
          }, null, 8, ["title", "body"])
        ]))
      : _createCommentVNode("", true)
  ]))
}